export default __webpack_public_path__ + "static/media/IconDesc_IronRods.256.4cc47f31.png";